module.exports = __webpack_public_path__ + "img/B256.bd39f739.png";